import styled from 'styled-components'

import { DASHBOARD_STYLED_CONSTS, PageLayout as PageLayoutComponent } from '@components'
import { mediaQueries } from '@fourthwall/components'

export const PageLayout = styled(PageLayoutComponent)`
  height: 100%;
`

export const AnalyticsTableWrapper = styled.div`
  position: sticky;
  top: calc(${DASHBOARD_STYLED_CONSTS.HEADER_HEIGHT}px + var(--space-500));

  #analytics-table {
    max-height: calc(100vh - ${DASHBOARD_STYLED_CONSTS.HEADER_HEIGHT}px - var(--space-500) * 2);
  }

  ${mediaQueries.tablet} {
    top: calc(${DASHBOARD_STYLED_CONSTS.HEADER_HEIGHT}px + var(--space-500));

    #analytics-table {
      max-height: calc(100vh - ${DASHBOARD_STYLED_CONSTS.HEADER_HEIGHT}px - var(--space-500) * 2);
    }
  }
`

export const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
`

export const ToolbarContent = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-200);

  ${mediaQueries.laptop} {
    display: none;
  }
`

export const Actions = styled.div`
  display: none;

  ${mediaQueries.laptop} {
    display: contents;
  }
`

export const HeaderSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-600);
`

export const DecoratorLabel = styled.div`
  display: flex;
  width: fit-content;
  padding: var(--space-100) var(--space-200);
  border-radius: var(--radius-brand);
  background: var(--bg-alert);
  color: var(--text-alert-tertiary);
  text-transform: uppercase;
  font-size: 10px;
  font-weight: var(--font-weight-semibold);
`
